// extracted by mini-css-extract-plugin
export default {"root":"n4KB4","title":"lsqv2","content":"Gafo6","closeButton":"aZV0Y"};